<template>
  <div fluid="md" class="mt-3" v-if="isLoggedIn">
    <h1 class="mb-3">
      {{ $t('res.td') }}
    </h1>
    <b-card class="mt-3" header-tag="nav" body-class="p-2 p-sm-4">
      <template #header>
        <b-nav card-header tabs>
          <b-nav-item :to="`/reservations/` + $route.params.uuid" link-classes="px-2 px-sm-3" exact exact-active-class="active">
            <b-icon-file-text v-if="!isXs" v-bind="iH" /> {{ $t('res.hde') }}
          </b-nav-item>
          <b-nav-item :to="`/reservations/` + $route.params.uuid +'/edit'" link-classes="px-2 px-sm-3" exact exact-active-class="active">
            <b-icon-tools v-if="!isXs" v-bind="iH" /> {{ $t('res.hed') }}
          </b-nav-item>
          <b-nav-item :to="`/reservations/` + $route.params.uuid +'/restaurant'" link-classes="px-2 px-sm-3" exact exact-active-class="active" v-if="isUser">
            <b-icon-shop v-if="!isXs" v-bind="iH" /> {{ $t('res.hre') }}
          </b-nav-item>
        </b-nav>
      </template>

      <router-view />
    </b-card>
  </div>
</template>

<script>
import { BIconShop, BIconFileText, BIconTools } from 'bootstrap-vue';
import { REST } from '@/components/RestCall';

export default {
  computed: {
    isLoggedIn() {
      return this.$store.state.oLogin.isLoggedIn;
    },
    isUser() {
      return this.$store.state.oLogin.isUser;
    },
    item() {
      return this.$store.state.oResDetails;
    },
    iH() {
      return this.$store.getters.iH;
    },
    isXs() {
      return this.$store.getters.isXs;
    },
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.replace('/').catch(() => {});
      return;
    }

    REST.get('/reservations/' + this.$route.params.uuid + '/' + (this.isUser ? 'user' : 'customer')
      ).then(resp => {
        this.$store.commit('setResDetails', resp.d.data);
      }).catch(() => {
        this.$router.push('/');
        this.$store.commit('showWarn',this.$t('rc.3'));
        this.$store.commit('setResDetails', null);
      })
  },
  beforeRouteUpdate(to, from, next) {
    if (this.item === null || to.params.uuid != from.params.uuid || (!from.name.startsWith('AnuReservations'))) {// && this.item.uuid4 !== to.params.uuid)) {
      REST.get('/reservations/' + to.params.uuid + '/' + (this.isUser ? 'user' : 'customer')
        ).then(resp => {
          this.$store.commit('setResDetails', resp.d.data);
          next();
        }).catch(() => {
          next('/');
          this.$store.commit('setResDetails', null);
          this.$store.commit('showWarn',this.$t('rc.3'));
        })
    } else {
      next();
    }
  },
  components: {
    BIconShop,
    BIconFileText,
    BIconTools,
  },
}
</script>
